"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const razorpayService_1 = require("./service/razorpayService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.create = (0, toolkit_1.createAsyncThunk)("razorpay/create", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const razorpayService = new razorpayService_1.RazorpayService(Env_1.APIPATHENV);
        const response = yield razorpayService.createOrder(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in creating order");
    }
}));
